import BusinessCategoryImportPage from './BusinessCategoryImportPage';

export default BusinessCategoryImportPage;
